module.exports = __webpack_public_path__ + "img/rings.25bc41a6.svg";